var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{domProps:{"textContent":_vm._s(_vm.formatDate(_vm.monthDate, _vm.formatDateHeadline))}}),_c('div',{staticClass:"event-days"},_vm._l((_vm.days),function(day){return _c('event-day',{key:day.date.toString(),staticClass:"event-day",attrs:{"dayDate":day.date,"events":day.events}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }